<style scoped>
  .v-datatable__actions__select {
    width: 20%;
  }
</style>
<template>
<v-container fluid pa-0>  
    <v-alert :value="true" type="success" dismissible v-model="alertSuccess">
        {{ resultMessage }}
    </v-alert>
    <v-alert :value="true" type="error" dismissible v-model="alertError">
        {{ resultMessage }}
    </v-alert>
      <v-toolbar class="elevation-1">
        <v-layout row>
          <v-flex xs12>
            <v-toolbar-title>  
              {{ middleManagerName }} - Classes
            </v-toolbar-title>
          </v-flex>
          
        </v-layout>
      </v-toolbar>
      <v-layout row>
          <v-flex xs7 style="padding-top: 1em; padding-left: 1em; padding-bottom: 0;">
            <v-layout row>
              <v-flex xs12>
                <v-radio-group v-model="selectedAllClassesOption" row style="float: right; font-size: 0.5em;">
                  <v-radio
                      v-for="n in optionsAllClasses"
                      :key="n.id"
                      :label="n.text"
                      :value="n.id" 
                      color="grey">
                  </v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs11>
                <v-text-field
                append-icon="search"
                label="Search"
                flat
                v-model="search"
                solo
              ></v-text-field>

              </v-flex>
              <v-flex xs2 centered>
                <v-btn color="green" outline  @click="addAll()">Add All</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs5 style="padding-top: 1em; padding-left: 1em; padding-bottom: 0;">
            <v-layout row>
              <v-flex xs12>
                <v-radio-group v-model="selectedGrantedClassesOption" row style="float: right;">
                  <v-radio
                      v-for="n in optionsGrantedClasses"
                      :key="n.id"
                      :label="n.text"
                      :value="n.id" 
                      color="grey">
                  </v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs9>
                <v-text-field
                append-icon="search"
                label="Filter Status"
                flat
                v-model="searchStatus"
                solo
              ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn color="red" outline @click="deleteAll()">Delete All</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs7 style="padding: 1em;">

        
          
        <!-- </v-layout> -->
          <v-card>
          <v-data-table
              :headers="headers"
              :items="items"
              item-key="rowId"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td width="20%">{{ props.item.code }}</td>
              <td width="20%">{{ props.item.course }}</td>
              <td width="20%">{{ props.item.name }}</td>
              <td>{{ props.item.teacher }}</td>
              <td disabled width="10%">
                <v-tooltip bottom>
                  <v-btn slot="activator" fab v-bind:dark="!readonly" small color="green" outline  v-bind:disabled="readonly"
                    @click.stop="addAssociation(props.item)"
                    v-bind:value="props.item.id"
                  ><v-icon dark>playlist_add</v-icon>
                  </v-btn>
                  <span>Add</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>    
          </v-card>
        </v-flex>
        <v-flex xs5 style="padding: 1em;">
          <v-card>
            <v-data-table
                :headers="headersStatus"
                :items="grantedClasses"
                item-key="rowId"
                :pagination.sync="paginationStatus"
                :total-items="totalItemsGranted"
                :loading="loadingStatus"
                :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td width="5%">{{ props.item.code }}</td>
                <td width="35%">{{ props.item.name }}</td>
                <td width="30%">{{ props.item.teacher }}</td>
                <td disabled width="5%">
                  <v-tooltip bottom>
                    <v-btn slot="activator" fab dark small color="red" outline
                      @click.stop="deleteAssociation(props.item)"
                    ><v-icon dark>delete</v-icon>
                    </v-btn>
                    <span>Revoke</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    <v-dialog v-model="dialog" max-width="35%">
      <v-card>
          <v-card-title>
              Confirmation
          </v-card-title>
          <v-card-text>
              <v-layout row wrap>
                 <v-layout row wrap>
                        This action will remove all the info related to the class &nbsp;  
                        <b>  {{ selectedClass }}  &nbsp; </b> 
                        from the period &nbsp; <b>{{ periodName }}</b>
                    </v-layout>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-btn color="primary" flat @click.stop="unloadDialog()">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.stop="deleteClass()">Delete</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog v-model="dialogManageTeachers" max-width="35%">
      <v-card>
          <v-card-title>
              Manage Teachers for Class {{ selectedClass }}
          </v-card-title>
          <v-card-text>
              <v-layout row wrap>
                 <v-layout row wrap>
                        This action will remove all the info related to the class &nbsp;  
                        <b>  {{ selectedClass }}  &nbsp; </b> 
                        from the period &nbsp; <b>{{ periodName }}</b>
                    </v-layout>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-btn color="primary" flat @click.stop="unloadManageTeachers()">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.stop="saveTeachers()">Save</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>
<script>
  import { getList, getListByPeriod, deleteClassManager, getManagerAssociations } from '../utils/effort-tracking-api'
  import { initialize, postClassManagerAssociation, getManagerClasses } from '../utils/effort-tracking-api'
  import { deleteAllAssociations, getMiddleManagerName, postAllClassManagerAssociations } from '../utils/effort-tracking-api'
  import { getAllClassesMiddleManagerAdmin, getManagerAssociationsByPeriod } from '../utils/effort-tracking-api'
  import { globalStore } from '../main'
  import { store } from '../store'

  export default {
    data () {
      return {
        search: '',
        loading: true,
        totalItems: 0,
        rowsPerPageItems: globalStore.rowsPerPageItems ,
        pagination: { sortBy: 'code', rowsPerPage: globalStore.defaultRowsPerPage },
        paginationStatus: { sortBy: 'code', rowsPerPage: globalStore.defaultRowsPerPage },
        dialog: false,
        dialogManageTeachers: false,
        periodName: '',
        selectedClass: '',
        selectedClassId: 0,
        alertSuccess: false,
        alertError: false,
        resultMessage: '',
        readonly: false,
        headers: [
          { text: 'Class Code', value: 'code' },
          { text: 'Course', value: 'course' },
          {text: 'Name', value: 'name' },
          {text: 'Teacher', value: 'teacher' },
          { text: 'Grant Access', value: '', sortable: false }
        ],
        items: [],
        grantedClasses: [],
        totalItemsGranted: 0,
        middleManagerId: 0,
        deleteAllHidden: true,
        middleManagerName: '',
        allResults: [],
        searchStatus: '',
        loadingStatus: false,
        headersStatus: [
          { text: 'Code', value: 'code' },
          {text: 'Name', value: 'name' },
          {text: 'Teacher', value: 'teacher' },
          { text: 'Actions', value: '', sortable: false }
        ],
        optionsAllClasses: [],
        optionsGrantedClasses: [],
        selectedAllClassesOption: 2,
        selectedGrantedClassesOption: 2,
        allGrantedClasses: []
      }
    },
     watch: {
      search: {
        handler() {
          this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler() {
          this.debouncedGetDataFromApi()
        },
        deep: true
      },
      searchStatus: {
        handler() {
          this.debouncedGetCurrentAccessStatus();
        }
      },
      paginationStatus: {
        handler() {
          this.debouncedGetCurrentAccessStatus();
        }
      },
      selectedAllClassesOption: {
        handler(value) {
          this.debouncedGetDataFromApi();
        }
      },
      selectedGrantedClassesOption: {
        handler(value) {
          this.debouncedGetCurrentAccessStatus();
        }
      }
    },
    mounted () {
      this.optionsAllClasses.push(
          { id: 1, text: 'All Reporting Periods' },
          { id: 2, text: 'Current Reporting Period' }
      );
      this.optionsGrantedClasses.push(
        { id: 1, text: 'All Reporting Periods'},
        { id: 2, text: 'Current Reporting Period'}
      );
      this.middleManagerId = this.$route.params.managerId;
      if(this.middleManagerId !== undefined)
      {
        localStorage.setItem('middlemanagerid', this.middleManagerId);
      } else {
        this.middleManagerId = localStorage.getItem('middlemanagerid');
      }
      this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true })
      this.debouncedGetCurrentAccessStatus = _.debounce(this.getCurrentAccessStatus, 500, { trailing:true })
    },
    methods: {
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getDataFromApi () {
        if(this.middleManagerId === undefined)
        {
          this.middleManagerId = localStorage.getItem('middlemanagerid');
        }
        initialize().then(x => {
          this.loading = true;
          getMiddleManagerName(this.middleManagerId).then(name => {
            this.middleManagerName = name;
          });

          if (this.selectedAllClassesOption == 1)
          {
            // Get classes from all reporting periods
            getAllClassesMiddleManagerAdmin(this.pagination, this.search).then(data => {
              this.items = data.items
              this.totalItems = data.count

              if(data.count > 0)
                this.allResults= data.items[0].allResults;
              this.loading = false;
            });
          } else {
            // Get classes of current reporting period
            getListByPeriod("classmanagers", this.pagination, this.search).then(data => {
              this.items = data.items
              this.totalItems = data.count

              if(data.count > 0)
                this.allResults= data.items[0].allResults;
              this.loading = false;
            });
          }
        });
      },
      getCurrentAccessStatus() {
        this.loadingStatus = true;
        initialize().then(x => {

          if (this.selectedGrantedClassesOption == 1)
          {
            getManagerAssociations(this.paginationStatus, this.middleManagerId, this.searchStatus).then(associations => {
              this.grantedClasses = associations.items;
              if(associations.count > 0)
                this.allGrantedClasses= associations.items[0].allResults;

              this.totalItemsGranted = associations.count;
              if(this.grantedClasses.length > 0)
                this.deleteAllHidden = false;

              this.loadingStatus = false;
            });
          } else {
            getManagerAssociationsByPeriod(this.paginationStatus, this.middleManagerId, this.searchStatus).then(associations => {
              this.grantedClasses = associations.items;
              if(associations.count > 0)
                this.allGrantedClasses= associations.items[0].allResults;

              this.totalItemsGranted = associations.count;
              if(this.grantedClasses.length > 0)
                this.deleteAllHidden = false;

              this.loadingStatus = false;
            });
          }
        });
      },
      addAssociation(_class) {
          this.loading = true;
          initialize().then(x => {
            postClassManagerAssociation(_class.id, this.middleManagerId).then(result => {
              this.loading = false;
              this.debouncedGetCurrentAccessStatus();
            });
          });
      },
      deleteAssociation(_class) {
        deleteClassManager(_class.classId, this.middleManagerId).then(result => {
          this.debouncedGetCurrentAccessStatus();
        });
      },
      deleteAll() {
        if(this.middleManagerId === undefined)
        {
          this.middleManagerId = localStorage.getItem('middlemanagerid');
        }
        initialize().then(x => {
          var classesToRemove = [];
          this.allGrantedClasses.forEach(element => {
            classesToRemove.push(element[0].classId);
          });

          deleteAllAssociations(this.middleManagerId, classesToRemove).then(result => {
            this.debouncedGetCurrentAccessStatus();
          });
        });
      },
      addAll() {
        if(this.middleManagerId === undefined)
        {
          this.middleManagerId = localStorage.getItem('middlemanagerid');
        }
        this.loading = true;
        initialize().then(x => {
          var classesToAdd = this.allResults;
          postAllClassManagerAssociations(this.middleManagerId, classesToAdd).then(result => {
            this.debouncedGetDataFromApi();
            this.debouncedGetCurrentAccessStatus();
          });
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/MiddleManagerClasses.vue